import exchange from "../assets/phaser-market/exchange-full.png";
import quests from "../assets/phaser-market/quests-full.png";
import liquidity from "../assets/phaser-market/liquidity-full.png";
export const MARKET_ART = { exchange, quests, liquidity } as const;
